import React from 'react';
import { MenuItem, Select } from '@mui/material';

export default function SettingsSelect({ label, value, disabled, onChange, options }) {
  return <div className="cp-select-field">
    <span>{label}</span>
    <Select size="small" value={value} disabled={disabled} onChange={e => onChange(e.target.value)} inputProps={{ 'aria-label': label }}
      MenuProps={{ PaperProps: { className: 'cp-select-menu' } }}>
      {options.map(([key, text]) => <MenuItem key={key} value={key}>{text}</MenuItem>)}
    </Select>
  </div>;
}
